/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The GroupOption model module.
* @module model/GroupOption
* @version 2020-12-7
*/
export default class GroupOption {
    /**
    * Constructs a new <code>GroupOption</code>.
    * グループ
    * @alias module:model/GroupOption
    * @class
    * @param id {Number} グループID
    * @param type {String} グループタイプ
    * @param name {String} グループ名
    * @param children {Array.<module:model/GroupOption>} 下位グループ
    */

    constructor(id, type, name, children) {
        
        
        this['id'] = id;
        this['type'] = type;
        this['name'] = name;
        this['children'] = children;
        
    }

    /**
    * Constructs a <code>GroupOption</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/GroupOption} obj Optional instance to populate.
    * @return {module:model/GroupOption} The populated <code>GroupOption</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new GroupOption();
                        
            
            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('type')) {
                obj['type'] = ApiClient.convertToType(data['type'], 'String');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('children')) {
                obj['children'] = ApiClient.convertToType(data['children'], [GroupOption]);
            }
        }
        return obj;
    }

    /**
    * グループID
    * @member {Number} id
    */
    'id' = undefined;
    /**
    * グループタイプ
    * @member {String} type
    */
    'type' = undefined;
    /**
    * グループ名
    * @member {String} name
    */
    'name' = undefined;
    /**
    * 下位グループ
    * @member {Array.<module:model/GroupOption>} children
    */
    'children' = undefined;




}
